import React, { useEffect, useState, useRef } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/login/Login";
import ROUTES_NAME from "./constants/RoutesName";
import { ToastContainer, toast } from "react-toastify";
import Instruction from "./pages/instruction/Instruction";
import Test from "./pages/test/Test";
import ContextProvider from "./context/ContextProvider";
import ThankyouPage from "./pages/thankyouPage/ThankyouPage";
import CenterFeedbackPage from "./pages/centerFeedback/CenterFeedbackPage";
import ExamScore from "./pages/examScore/ExamScore";
import DisableDevtool from "disable-devtool";
import useDevToolsDetection from "./useDevToolsDetection";
import AuthError from "./pages/AuthError";
import DashboardMain from "./pages/dashboard/dashboardMain";
import { loginByClintApi, verifyPreviewTokenApi } from "./services/service";
import DisableCopyPaste from "./DisableCopyPaste";
import useWakeLock from "./useWakeLock";
import SubjectSelection from "./pages/subjectSelection/SubjectSelection";
import Loader from "./components/Loader";
import { decryptData } from "./crypto";

function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [subjectSelectionPage, setSubjectSelectionPage] = useState(false);
  const [
    candidateLoggedinStateToInstructionsPage,
    setCandidateLoggedinStateToInstructionsPage,
  ] = useState(false);
  const [examStartedState, setExamStartedState] = useState(false);
  const [candidateLoggedinToDashboard, setCandidateLoggedinToDashboard] =
    useState(false);
  const [candidateOnFaceVerification, setCandidateOnFaceVerification] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [previewVerifying, setPreviewVerifying] = useState(false);
  // const [previewError, setPreviewError] = useState(null);
  const hasVerifiedRef = useRef(false);

  const location = useLocation();
  const navigate = useNavigate();

  useWakeLock();

  useEffect(() => {
    DisableDevtool({
      // url: "/auth-error",
      disableMenu: true,
      clearIntervalWhenDevOpen: false,
    });

    const examToken = sessionStorage.getItem("examToken");
    const userName = sessionStorage.getItem("userName");

    const candidateLoggedinToInstructionsPage = sessionStorage.getItem(
      "candidateLoggedinToInstructionsPage"
    );

    const subjectSelection = sessionStorage.getItem(
      "subjectSelection"
    );

    const examStarted = sessionStorage.getItem("examStarted");
    const dashboardAccess = sessionStorage.getItem(
      "candidateLoggedinToDashboard"
    );

    if (examToken && userName) {
      setIsLoggedIn(true);
    }
    if (dashboardAccess) {
      setCandidateLoggedinToDashboard(dashboardAccess === "true" || dashboardAccess === "yes");
    }

    if (candidateLoggedinToInstructionsPage) {
      setCandidateLoggedinStateToInstructionsPage(candidateLoggedinToInstructionsPage === "true" || candidateLoggedinToInstructionsPage === "yes");
    }
    if (subjectSelection) {
      setSubjectSelectionPage(subjectSelection === "true" || subjectSelection === "yes");
    }
    if (examStarted) {
      setExamStartedState(examStarted === "true" || examStarted === "yes");
    }
    setLoading(false);
  }, []);

  const urlParams = new URLSearchParams(window.location.search);
  const key = urlParams.get("transferKey");
  const ptoken = urlParams.get("ptoken") || urlParams.get("preview_token");
  const examIdParam = urlParams.get("exam_id");

  const parseTransferKey = (rawKey) => {
    if (!rawKey) return null;
    // 1. Try decrypting if encrypted (CryptoJS AES)
    try {
      const decrypted = decryptData(rawKey);
      if (decrypted) {
        return JSON.parse(decrypted);
      }
    } catch (e) {}
    // 2. Fallback try direct JSON parse
    try {
      return JSON.parse(rawKey);
    } catch (e) {}
    return null;
  };

  const loginByClint = async (data) => {
    sessionStorage.setItem("loginByClient", true);

    try {
      const response = await loginByClintApi(data);
      if (response.success) {
        window.location.href = window.location.origin;
        sessionStorage.setItem("loginByClient", true);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (hasVerifiedRef.current) return;

    const handlePreviewAndLogin = async () => {
      hasVerifiedRef.current = true;

      const transferData = parseTransferKey(key);
      const examId = examIdParam || transferData?.exam_id;

      // 1. If ptoken is present, hit verify API first before rendering content
      if (ptoken) {
        setPreviewVerifying(true);
        const verifyRes = await verifyPreviewTokenApi({
          preview_token: ptoken,
          exam_id: examId,
        });

        if (!verifyRes.success || !verifyRes.verified) {
          // toast.error(
          //   verifyRes.message || "Preview link is invalid, expired, or already used"
          // );
          setPreviewVerifying(false);
          navigate(ROUTES_NAME.LOGIN, { replace: true });
          return;
        }
        setPreviewVerifying(false);
      }

      // 2. If transferData exists, trigger auto-login
      if (transferData) {
        await loginByClint(transferData);
        sessionStorage.setItem("transferKey", JSON.stringify(transferData));
      }
    };

    if (ptoken || key) {
      handlePreviewAndLogin();
    }
  }, [key, ptoken, examIdParam, navigate]);

  const handleLogin = () => {
    setIsLoggedIn(true);
    setCandidateLoggedinToDashboard(
      sessionStorage.getItem("candidateLoggedinToDashboard") === "true"
    );
  };

  if (loading || previewVerifying) {
    return <Loader />;
  }
  // if (previewError) {
  //   return <PreviewError message={previewError} />;
  // }
  return (
    <ContextProvider>
      <ToastContainer />
      <Routes location={location}>
        <Route
          path={ROUTES_NAME.LOGIN}
          element={
            isLoggedIn && examStartedState ? (
              <Navigate to={ROUTES_NAME.TEST} />
            ) : isLoggedIn && candidateLoggedinStateToInstructionsPage ? (
              <Navigate to={ROUTES_NAME.INSTRUCTION} />
            ) : isLoggedIn && subjectSelectionPage ? (
              <Navigate to={ROUTES_NAME.SUBJECT_SELECTION} />
            )
              : isLoggedIn && candidateLoggedinToDashboard ? (
                <Navigate to={ROUTES_NAME.DASHBOARD} />
              ) : (
                <Login handleLogin={handleLogin} />
              )
          }
        />
        <Route
          path={ROUTES_NAME.INSTRUCTION}
          element={
            isLoggedIn ? <Instruction /> : <Navigate to={ROUTES_NAME.LOGIN} />
          }
        />
        <Route
          path={ROUTES_NAME.SUBJECT_SELECTION}
          element={
            isLoggedIn ? <SubjectSelection /> : <Navigate to={ROUTES_NAME.LOGIN} />
          }
        />

        <Route
          path={ROUTES_NAME.TEST}
          element={isLoggedIn ? <Test /> : <Navigate to={ROUTES_NAME.LOGIN} />}
        />

        <Route
          path={ROUTES_NAME.CENTER_FEEDBACK}
          element={
            isLoggedIn ? (
              <CenterFeedbackPage />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path={ROUTES_NAME.THANK_YOU}
          element={
            isLoggedIn ? (
              <ThankyouPage handleLogin={handleLogin} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path={ROUTES_NAME.DASHBOARD}
          element={
            isLoggedIn && candidateLoggedinToDashboard ? (
              <DashboardMain />
            ) : (
              <Navigate to={ROUTES_NAME.LOGIN} />
            )
          }
        />

        <Route
          path={ROUTES_NAME.REGISTRATION}
          element={
            isLoggedIn && candidateLoggedinToDashboard ? (
              <DashboardMain />
            ) : (
              <Navigate to={ROUTES_NAME.LOGIN} />
            )
          }
        />
        <Route
          path={ROUTES_NAME.EXAM_SCORE}
          element={isLoggedIn ? <ExamScore /> : <Navigate to="/" />}
        />
        <Route path={ROUTES_NAME.AUTH_ERROR} element={<AuthError />} />
        <Route path="*" element={<Navigate to={ROUTES_NAME.LOGIN} />} />
      </Routes>
    </ContextProvider>
  );
}

function App() {
  return (
    <>
      <DisableCopyPaste>
        <AppRoutes />
      </DisableCopyPaste>
    </>
  );
}

export default App;
